export default "__VITE_ASSET__B1geegwA__"